<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, computed, } from 'vue';

import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import ClauseBox from '@/components/cloudCounter/clauseBox.vue';


import { useRouter } from 'vue-router';
const router = useRouter();

// 條款
const clauseLList = ref([
    {
        viewed: false,
        title: '個人資料蒐集、處理及利用告知事項處理及利用告知事項',
        content: [
            ['壹、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['貳、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['參、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['參、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['肆、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['伍、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['6、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['7、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['8、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['9、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['9、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
            ['10、', '「保單借款利率」、「借款利息計算方式」及「撥款方式」將會於「保單借款約定書」中 另行約定揭露。 說明：一、借款人申請借款之金額，以借款當時保險契約之保單價值準備金或保單帳戶價 值範圍內為限。'],
        ]
    },
    {
        viewed: false,
        title: 'AAAAAAAAAAA',
        content: 'BBBBBBBBB'
    }
]);

const clauseAllOk = computed(() => {
    return clauseLList.value.every(item => item.viewed === true);
})


const infoBoxBottomData = ref(null);

const setInfoBoxBottom = (item) => {
    infoBoxBottomData.value = (item) ? item : null;
}


const goNextPage = () => {
    router.push({ name: 'cloudCounterVideoOperationLogin' })
}


</script>

<template>

    <Layout :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="0"></Process>
        </div>

        <div class="pb-4">
            <h2 class="font-bold text-2xl">
                服務約定條款
            </h2>
        </div>

        <CaseBox>
            <ul>
                <li class="cursor-pointer py-3 flex" v-for="(clause, i) in clauseLList" :class="{ 'border-t': i !== 0 }"
                    @click="(e) => { setInfoBoxBottom(clause) }">

                    <div>
                        <div class="inline-block w-[20px] h-[20px] rounded-sm border align-bottom text-white"
                            :class="{ 'bg-[#0093C1] border-[#0093C1]': clause.viewed }">

                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                style="width: 18px; height: 18px;">
                                <title>check</title>
                                <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                            </svg>
                        </div>
                    </div>
                    <div class="flex-1 px-3">
                        {{ clause.title }}
                    </div>
                    <div class="text-[#0093C1]">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                            style="width: 24px; height: 24px;">
                            <title>chevron-right</title>
                            <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                        </svg>
                    </div>
                </li>
            </ul>
        </CaseBox>

        <ClauseBox :infoBoxBottomData="infoBoxBottomData" :closeHandle="() => { setInfoBoxBottom(null) }"
            v-if="infoBoxBottomData" />

        <!-- {{ clauseLList }} -->
        <!-- {{ clauseAllOk }} -->

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="!clauseAllOk" @click="goNextPage">看預約申請內容</button>
        </template>

    </Layout>

</template>

<style scoped></style>
